// Prettier glyphs for operator suggestion buttons — same symbol set as `OPERATORS`
// (@Components/MetricsTable/metrics-table-utils) but easier to read on a button.
export const OPERATOR_LABEL_MAP: Record<string, string> = {
  '*': 'x',
  '/': '÷',
  '^': '**'
};

export const FORMAT_OPTIONS = [
  { label: 'Number (123)', value: 'number' },
  { label: 'Percent (12.3%)', value: 'percent' },
  { label: 'Money ($123)', value: 'spend' }
];
